/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useSyncExternalStore } from 'react';

import { useWishlistStore } from '@/store/wishlistStore';

interface WishlistCountContextValue {
  itemCount: number;
}

const WishlistCountContext = createContext<WishlistCountContextValue | undefined>(undefined);

export const WishlistCountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const itemCount = useSyncExternalStore(
    useWishlistStore.subscribe,
    () => useWishlistStore.getState().itemCount,
    () => 0
  );

  return (
    <WishlistCountContext.Provider value={{ itemCount }}>{children}</WishlistCountContext.Provider>
  );
};

export const useWishlistCount = (): WishlistCountContextValue => {
  const ctx = useContext(WishlistCountContext);
  if (!ctx) {
    throw new Error('useWishlistCount must be used within a <WishlistCountProvider>');
  }
  return ctx;
};
